module.exports = __webpack_public_path__ + "static/media/boot.8340a799.svg";